<template>
  <div class="container">
    <!--    <p style="position: absolute;top: 10px;left: 10px;">currentIndex = {{currentIndex}}; translateX = {{translateX}}; </p>-->
    <div class="left">
      <div class="button left-button" @click="tabScroll(false)" v-if="currentIndex > 0">
        <img :src="ossPath + '/pages/home/icon_page_left.png'" alt="">
      </div>
    </div>
    <div class="right">
      <div class="button right-button" @click="tabScroll(true)" v-if="sharedWarehouseLine.length >=3 && currentIndex < sharedWarehouseLine.length - 2">
        <img :src="ossPath + '/pages/home/icon_page_right.png'" alt="">
      </div>
    </div>
    <div class="scroll-box">
      <div class="country_warehouse_List" id="homeCloudWarehouse" :style="scrollStyle">
        <div class="country_warehouse_item" v-for="item in sharedWarehouseLine" :key="item.countryWareName">
          <el-carousel arrow="never"
                       indicator-position="none"
                       :initial-index="0"
                       height="100%"
                       style="height: 100%">
            <el-carousel-item v-for="(lineList, index) in item.datWareLineDTOList" :key="index">
              <div style="padding: 14px 14px 0 19px;">
                <div style="display: flex;justify-content: space-between;align-items: center;">
                  <p class="country_line_name" style="">{{ item.countryWareName }}</p>
                  <div class="look_more" @click="handleMore(item)">
                    <span>查看更多</span>
                    <img :src="ossPath + '/pages/home/yun_warehouse/icon_apply_arrow.png'" alt="" style="width: 6px;height: 11px;margin-left: 2px;">
                  </div>
                </div>
                <div class="line_list"  v-for="(line, i) in lineList" :key="i">
                  <div class="line_list_item">
                    <div class="line_icon">
                      <el-avatar :src="line.logoUrl || defaultIcon" fit="contain" alt="" style="width: 100%;height: 100%" :class="{blur: isCarrierNameBlurring}" />
                    </div>
                    <div class="line_info">
                      <div>
                        <p class="carrier_name" :class="{blur: isCarrierNameBlurring}">{{ line.specialLineName }}</p>
                        <p class="line_name" :class="{blur: isCarrierNameBlurring}">{{ line.productName || '-' }}</p>
                      </div>
                      <div style="max-width: 140px;flex-shrink: 0">
                        <template v-if="line.isNeedInquiry">
                          <span class="original_price">单询</span>
                        </template>
                        <template v-else>
                          <div style="text-align:right;" v-if="line.priceHeaderRank === 2">
                            <img :src="ossPath + '/pages/queryPrice/vip_price_4.png'" alt="">
                          </div>
                          <template v-if="line.discountedPrice">
                            <price-blurring
                              :price="`${line.discountedPrice}/${line.billingUnit}`"
                              :currency="line.currency"
                              class="original_price"
                            />
                            <price-blurring
                              :price="`${line.minPrice}/${line.billingUnit}`"
                              :currency="`原价 ${line.currency}`"
                              class="discounted_price"
                            />
                          </template>
                          <template v-else>
                            <price-blurring
                              :price="`${line.minPrice}/${line.billingUnit}`"
                              :currency="line.currency"
                              class="original_price"
                            />
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { ossPath } from '../../../../../devParams';
import PriceBlurring from "../../../../../common/priceBlurring/index.vue";
import {sendCustomerOperationRecord} from "../../../../assets/js/utils";
import {mapGetters, mapState} from "vuex";
export default {
  components: {PriceBlurring},
  props: {

  },
  data() {
    return {
      defaultIcon: ossPath + "/pages/home/hot_country_default_icon.png",
      // 列表
      sharedWarehouseLine: [],
      // 当前滚动到的index
      currentIndex:0,
      // 当前滚动距离
      translateX:0,
      boxWidth:449,
      boxMarginRight:17,
      leftPadding:33,
    }
  },
  computed:{
    // 第一屏第三个容器展示出来的前一半（左半边）宽度
    scrollStyle(){
      return `transform: translateX(${-this.translateX}px);`;
    },
    maxIndex(){
      let l =  this.sharedWarehouseLine.length || 0;
      if(l>=3) l -= 2;
      return l;
    },
    ...mapGetters(["realNameState","realNameType","token","isInquiryUserSuccess"]),
    ...mapState(['Authorization']),
    isCarrierNameBlurring() {
      if (!this.token) return true;
      if(this.Authorization.temporaryAuthentication) return false;
      if(this.isInquiryUserSuccess) return false
      if(this.realNameType === 1 && this.realNameState === 1) return false;
      // if (this.realNameType === 7) return true
      return this.realNameState !== 3;
    }
  },
  methods: {
    tabScroll(toRight) {
      let index = this.currentIndex;
      let x = this.translateX;
      if (toRight) {
        if(index < this.maxIndex){
          index ++;
        }
        if(index <= 0) index = 1;
        x = this.leftPadding + (this.boxWidth + this.boxMarginRight) * index - this.boxMarginRight;
      }else {
        if(index > this.maxIndex){
          index = this.maxIndex - 1;
        }else{
          index --
        }
        if(index<0) index = 0;
        if(index === 0){
          x = 0;
        }else{
          x = this.leftPadding + (this.boxWidth + this.boxMarginRight) * index - this.boxMarginRight;
        }
      }
      this.currentIndex = index;
      this.translateX = x;
    },
    getSharedWarehouseLine() {
      this.axios.get('/api/datShareWarehouse/getYunCangLineList')
        .then(res => {
          if (res.data.code === 200) {
            let list = res.data.data.datWareCountyList || []
            list.forEach(item => {
              item.datWareLineDTOList = this.groupArray(item.datWareLineDTOList)
            })
            this.sharedWarehouseLine = list;
            this.currentIndex = 0;
            this.translateX = 0;
          } else {
            this.sharedWarehouseLine = [];
            this.currentIndex = 0;
            this.translateX = 0;
          }
        })
    },
    groupArray(arr, groupSize=3) {
      const result = [];
      for (let i = 0; i < arr.length; i += groupSize) {
        result.push(arr.slice(i, i + groupSize));
      }
      return result;
    },
    handleMore(item) {
      console.log(item)
      if (item.datWareLineDTOList && item.datWareLineDTOList.length && item.datWareLineDTOList[0] && item.datWareLineDTOList[0].length) {
        const lineInfo = item.datWareLineDTOList[0][0]
        console.log(lineInfo)
        let data = {
          fromCityid: lineInfo.polLandId,
          fromstoreName: lineInfo.polLandName,
          toCountryid: lineInfo.polCountryId,
          tocountryName: lineInfo.polCountryName,
          toWarehouseInfo: {
            id: '',
            namec: ''
          },
          transportCodes: 'ALL',
          toStoreid: '',
          podlandType: 0,
          isShareWarehouseLine: true,
          transportSchemeId: lineInfo.transportSchemeId
        }
        sendCustomerOperationRecord('货代拼云仓', `查看更多:${item.countryWareName}`);
        this.$router.push({
          name: "queryPrice",
          query: {
            searchData: JSON.stringify(data),
          },
        })
      }
    }
  },
  created() {
    this.getSharedWarehouseLine()
  }
}
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  padding: 20px 0 20px;
  width: 100%;
  height: 100%;
  position: relative;
}
.button {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  i {
    font-size: 20px;
    font-weight: 500;
    color: #999;
  }
  &:hover {
    cursor: pointer;
  }
}
.left {
  position: absolute;
  z-index: 2;
  left: -40px;
  top: 50%;
  transform: translateY(-50%);
}
.right {
  position: absolute;
  z-index: 2;
  right: -40px;
  top: 50%;
  transform: translateY(-50%);
}
.scroll-box{
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  z-index: 1;
  flex-wrap: nowrap;
}
.country_warehouse_List {
  position: relative;
  z-index: 1;
  display: flex;
  padding-left: 0;
  width: auto;
  transition: transform 0.8s ease;
  transform: translateX(0px);
  &::-webkit-scrollbar {
    display: none;
  }
}
.country_warehouse_item {
  flex-shrink: 0;
  width: 380px;
  height: 280px;
  margin-right: 29px;
  background: rgba(255,255,255,0.9);
  border-radius: 20px;
  transition: background-color .3s ease;
  &:hover {
    background: rgba(255,255,255,1);
  }

  .country_line_name {
    font-size: 20px;
    font-weight: 500;
    color: #141414;
    padding-left: 6px;
  }

  /deep/ .el-carousel__indicators--horizontal {
    bottom: 15px;
    .el-carousel__button {
      width: 50px;
      height: 4px;
      background: #CECECE;
    }
  }
  /deep/ .el-carousel__indicator{

    &.is-active{
      .el-carousel__button{
        background: #FF4D01 !important;
      }
    }
  }
}
.look_more {
  width: 74px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background: transparent;
  border-radius: 18px;
  font-size: 13px;
  font-family: PingFang SC;
  color: #FF4D01;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #FF4D01;
  i {
    font-weight: bold;
  }
}
.line_list {
  margin-top: 21px;
  &_item {
    display: flex;
    align-items: center;
    .line_icon {
      width: 50px;
      height: 50px;
      box-shadow: 0px 0px 24px 0px rgba(99,92,93,0.14);
      border-radius: 32px;
      overflow: hidden;
      margin-right: 20px;
    }
    .line_info {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 1;
      .carrier_name {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #141414;
      }
      .line_name {
        margin-top: 4px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 17px;
      }
      .original_price {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FF4D01;
        line-height: 22px;
      }
      .discounted_price {
        margin-top: 1px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 400;
        text-decoration: line-through;
        color: #999999;
      }
    }
  }
}
.blur {
  filter: blur(5px);
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/sharedWarehouseLine/home.vue